// // utils/API/BackendHelper/admin/sme.js

// import ApiHelper from '../../ApiHelper';
// import API_ENDPOINTS from '../../endpoints';   

// class SMEHelper {
//     async getAllSMEs(params = {}) {
//         try {
//             const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SMES, params);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to fetch SMEs: ${error.message}`);
//         }
//     }

//     async getSMEById(smeId) {
//         try {
//             const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId));
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to fetch SME by ID: ${error.message}`);
//         }  
//     }

//     async createSME(smeData) {
//         try {
//             const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.CREATE_SME, smeData);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to create SME: ${error.message}`);
//         }
//     }

//     async updateSME(smeId, smeData) {
//         try {
//             const response = await ApiHelper.put(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId), smeData);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to update SME: ${error.message}`);
//         }
//     }

//     async deleteSME(smeId) {
//         try {
//             const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId));
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to delete SME: ${error.message}`);
//         }
//     }

//     async activateSME(smeId) {
//         try {
//             const response = await ApiHelper.patch(API_ENDPOINTS.ADMIN.SME_ACTIVATE(smeId));
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to activate SME: ${error.message}`);
//         }
//     }

//     async deactivateSME(smeId) {
//         try {
//             const response = await ApiHelper.patch(API_ENDPOINTS.ADMIN.SME_DEACTIVATE(smeId));
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to deactivate SME: ${error.message}`);
//         }
//     }

//     async toggleSMEAvailability(smeId, isAvailable) {
//         try {
//             const response = await ApiHelper.patch(API_ENDPOINTS.ADMIN.SME_AVAILABILITY(smeId), {
//                 isAvailable
//             });
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to toggle SME availability: ${error.message}`);
//         }
//     }

//     async searchSMEs(searchTerm, options = {}) {
//         try {
//             const params = { q: searchTerm, ...options };
//             const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_SEARCH, params);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to search SMEs: ${error.message}`);
//         }
//     }

//     async getSMEsBySubject(subject, options = {}) {
//         try {
//             const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_BY_SUBJECT(subject), options);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to fetch SMEs by subject: ${error.message}`);
//         }
//     }

//     async getSMEsBySubjects(subjects, options = {}) {
//         try {
//             const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.SME_BY_SUBJECTS, {
//                 subjects,
//                 ...options
//             });
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to fetch SMEs by subjects: ${error.message}`);
//         }
//     }

//     async getSMEStatistics() {
//         try {
//             const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_STATISTICS);
//             return response;
//         } catch (error) {
//             throw new Error(`Failed to fetch SME statistics: ${error.message}`);
//         }
//     }
// }

// export default new SMEHelper();
// utils/API/BackendHelper/admin/sme.js

import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';
import axios from 'axios'; // make sure axios is installed in your project

// --- Helpers ---
function normalizeSubjects(subjects) {
  if (!subjects) return [];
  if (Array.isArray(subjects)) {
    return subjects.map(s => (typeof s === 'string' ? s.trim() : s)).filter(Boolean);
  }
  if (typeof subjects === 'string') {
    // accept comma-separated string as fallback
    return subjects.split(',').map(s => s.trim()).filter(Boolean);
  }
  return [];
}

function cleanSMEPayload(raw = {}) {
  const {
    email,
    password,
    firstName,
    lastName,
    subjects,
    specialization,
    phone,
    qualification,
    experienceYears,
    bio,
    languages,
    availabilityHours,
    isAvailable,
    isSmeActive,
    isActive,
    ...other
  } = raw || {};

  const payload = {
    ...(typeof email === 'string' && email.trim() ? { email: email.trim() } : {}),
    ...(typeof password === 'string' && password ? { password } : {}),
    ...(typeof firstName === 'string' && firstName.trim() ? { firstName: firstName.trim() } : {}),
    ...(typeof lastName === 'string' && lastName.trim() ? { lastName: lastName.trim() } : {}),

    // Always include subjects as an array (may be empty)
    subjects: normalizeSubjects(subjects),

    ...(typeof specialization === 'string' && specialization.trim()
      ? { specialization: specialization.trim() }
      : {}),

    ...(typeof qualification === 'string' && qualification.trim()
      ? { qualification: qualification.trim() }
      : {}),

    ...(typeof phone === 'string' && phone.trim() ? { phone: phone.trim() } : {}),

    ...(typeof bio === 'string' && bio.trim() ? { bio: bio.trim() } : {}),

    ...(experienceYears !== undefined && experienceYears !== null && experienceYears !== ''
      ? (() => {
          const num = Number(experienceYears);
          return Number.isFinite(num) ? { experienceYears: num } : {};
        })()
      : {}),
    
    // Languages array
    ...(Array.isArray(languages) && languages.length > 0
      ? { languages: languages.filter(l => typeof l === 'string' && l.trim()) }
      : {}),
    
    // Availability hours object
    ...(availabilityHours && typeof availabilityHours === 'object'
      ? { availabilityHours }
      : {}),
    
    // Boolean flags
    ...(typeof isAvailable === 'boolean' ? { isAvailable } : {}),
    ...(typeof isSmeActive === 'boolean' ? { isSmeActive } : {}),
    ...(typeof isActive === 'boolean' ? { isActive } : {}),
    
    // include other primitive non-empty keys defensively
    ...Object.fromEntries(
      Object.entries(other).filter(([k, v]) => {
        if (v === undefined || v === null) return false;
        if (typeof v === 'string' && v.trim() === '') return false;
        if (Array.isArray(v) && v.length === 0) return false;
        return true;
      })
    )
  };

  return payload;
}

function extractErrorMessage(err) {
  if (!err) return 'Unknown error';
  if (err.response && err.response.data) {
    const d = err.response.data;
    if (typeof d === 'string') return d;
    if (d.message) return d.message;
    if (d.errors) return JSON.stringify(d.errors);
    return JSON.stringify(d);
  }
  if (err.message) return err.message;
  return String(err);
}

// --- SME Helper Class ---
class SMEHelper {
  async getAllSMEs(params = {}) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SMES, params);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch SMEs: ${extractErrorMessage(error)}`);
    }
  }

  async getSMEById(smeId) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId));
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch SME by ID: ${extractErrorMessage(error)}`);
    }
  }

  async createSME(smeData) {
    const payload = cleanSMEPayload(smeData);

    // DEBUG (remove or gate behind env flag if noisy)
    // console.log('createSME payload:', JSON.stringify(payload, null, 2));

    // Try ApiHelper first (most projects prefer using a single wrapper)
    try {
      // If ApiHelper.post accepts (url, data, config) this will work.
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.CREATE_SME, payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      return response;
    } catch (err) {
      // If ApiHelper isn't sending the JSON body as expected, fallback to axios
      // This fallback is intentionally conservative — keep it for debugging.
      try {
        const url = API_ENDPOINTS.ADMIN.CREATE_SME;
        const axiosResp = await axios.post(url, payload, {
          headers: { 'Content-Type': 'application/json' }
        });
        return axiosResp.data;
      } catch (axiosErr) {
        throw new Error(`Failed to create SME: ${extractErrorMessage(axiosErr)}`);
      }
    }
  }

  async updateSME(smeId, smeData) {
    const payload = cleanSMEPayload(smeData);

    try {
      const response = await ApiHelper.put(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId), payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      return response;
    } catch (err) {
      // fallback to axios if ApiHelper fails
      try {
        const url = API_ENDPOINTS.ADMIN.SME_BY_ID(smeId);
        const axiosResp = await axios.put(url, payload, {
          headers: { 'Content-Type': 'application/json' }
        });
        return axiosResp.data;
      } catch (axiosErr) {
        throw new Error(`Failed to update SME: ${extractErrorMessage(axiosErr)}`);
      }
    }
  }

  async deleteSME(smeId) {
    try {
      const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.SME_BY_ID(smeId));
      return response;
    } catch (error) {
      throw new Error(`Failed to delete SME: ${extractErrorMessage(error)}`);
    }
  }

  async activateSME(smeId) {
    try {
      const response = await ApiHelper.patch(API_ENDPOINTS.ADMIN.SME_ACTIVATE(smeId));
      return response;
    } catch (error) {
      throw new Error(`Failed to activate SME: ${extractErrorMessage(error)}`);
    }
  }

  async deactivateSME(smeId) {
    try {
      const response = await ApiHelper.patch(API_ENDPOINTS.ADMIN.SME_DEACTIVATE(smeId));
      return response;
    } catch (error) {
      throw new Error(`Failed to deactivate SME: ${extractErrorMessage(error)}`);
    }
  }

  async toggleSMEAvailability(smeId, isAvailable) {
    try {
      const response = await ApiHelper.patch(
        API_ENDPOINTS.ADMIN.SME_AVAILABILITY(smeId),
        { isAvailable },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response;
    } catch (error) {
      throw new Error(`Failed to toggle SME availability: ${extractErrorMessage(error)}`);
    }
  }

  async searchSMEs(searchTerm, options = {}) {
    try {
      const params = { q: searchTerm, ...options };
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_SEARCH, params);
      return response;
    } catch (error) {
      throw new Error(`Failed to search SMEs: ${extractErrorMessage(error)}`);
    }
  }

  async getSMEsBySubject(subject, options = {}) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_BY_SUBJECT(subject), options);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch SMEs by subject: ${extractErrorMessage(error)}`);
    }
  }

  async getSMEsBySubjects(subjects, options = {}) {
    try {
      const body = {
        subjects: normalizeSubjects(subjects),
        ...options
      };

      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.SME_BY_SUBJECTS, body, {
        headers: { 'Content-Type': 'application/json' }
      });
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch SMEs by subjects: ${extractErrorMessage(error)}`);
    }
  }

  async getSMEStatistics() {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.SME_STATISTICS);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch SME statistics: ${extractErrorMessage(error)}`);
    }
  }
}

export default new SMEHelper();
